import { Component, OnInit } from "@angular/core";
import { Meta, Title } from "@angular/platform-browser";
import { StorageService } from "src/app/core/storage/storage.service";
@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.css"],
})
export class FooterComponent implements OnInit {
  title = "#1 HRMKING - Best HR and Payroll Management Software";
  constructor(
    private storageService: StorageService,
    private titleMeta: Title,
    private meta: Meta
  ) {}

  ngOnInit() {
    ///////////////////////meta tag/////////////////

    this.meta.addTags([
      { charset: "UTF-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      { name: "date", content: "2023-01-01", scheme: "YYYY-MM-DD" },
      {
        name: "keywords",
        content:
          "HR Software, Payroll Software, Attendance Management, Salary Slip, Payroll Management, accounts, invoice, CRM, Projects",
      },
      { name: "author", content: "Srmak Technological System Private Limited" },
      { name: "robots", content: "index, follow" },
    ]);

    ////////////////////////title meta///////////////////////

    this.titleMeta.setTitle(this.title);

    /////////////////////////////////////////////////
  }

  plusIcon1 = false;
  plusIcon2 = false;
  plusIcon3 = false;

  minusIcon1 = true;
  minusIcon2 = true;
  minusIcon3 = true;

  public FMGC = false;
  public Electronics = true;
  public Hardwere = true;
  public Kirana = true;
  public Jewellary = true;
  public Pharma = true;
  public Transportation = true;

  showText(val) {
    if (val === "1") {
      this.plusIcon1 = true;
      this.plusIcon2 = false;
      this.plusIcon3 = false;

      this.minusIcon1 = false;
      this.minusIcon2 = true;
      this.minusIcon3 = true;
    }

    if (val === "11") {
      this.plusIcon1 = false;
      this.plusIcon2 = false;
      this.plusIcon3 = false;

      this.minusIcon1 = true;
      this.minusIcon2 = true;
      this.minusIcon3 = true;
    }

    ////////////////////////////////////////////////////////////
    else if (val === "2") {
      this.plusIcon1 = false;
      this.plusIcon2 = true;
      this.plusIcon3 = false;

      this.minusIcon1 = true;
      this.minusIcon2 = false;
      this.minusIcon3 = true;
    }

    if (val == "22") {
      this.plusIcon1 = false;
      this.plusIcon2 = false;
      this.plusIcon3 = false;

      this.minusIcon1 = true;
      this.minusIcon2 = true;
      this.minusIcon3 = true;
    } else if (val === "3") {
      this.plusIcon1 = false;
      this.plusIcon2 = false;
      this.plusIcon3 = true;

      this.minusIcon1 = true;
      this.minusIcon2 = true;
      this.minusIcon3 = false;
    }
    if (val === "33") {
      this.plusIcon1 = false;
      this.plusIcon2 = false;
      this.plusIcon3 = false;

      this.minusIcon1 = true;
      this.minusIcon2 = true;
      this.minusIcon3 = true;
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////

  showComment(val) {
    if (val == "1") {
      this.FMGC = false;
      this.Electronics = true;
      this.Hardwere = true;
      this.Kirana = true;
      this.Jewellary = true;
      this.Pharma = true;
      this.Transportation = true;
    } else if (val == "2") {
      this.FMGC = true;
      this.Electronics = false;
      this.Hardwere = true;
      this.Kirana = true;
      this.Jewellary = true;
      this.Pharma = true;
      this.Transportation = true;
    } else if (val == "3") {
      this.FMGC = true;
      this.Electronics = true;
      this.Hardwere = false;
      this.Kirana = true;
      this.Jewellary = true;
      this.Pharma = true;
      this.Transportation = true;
    } else if (val == "4") {
      this.FMGC = true;
      this.Electronics = true;
      this.Hardwere = true;
      this.Kirana = false;
      this.Jewellary = true;
      this.Pharma = true;
      this.Transportation = true;
    } else if (val == "5") {
      this.FMGC = true;
      this.Electronics = true;
      this.Hardwere = true;
      this.Kirana = true;
      this.Jewellary = false;
      this.Pharma = true;
      this.Transportation = true;
    } else if (val == "6") {
      this.FMGC = true;
      this.Electronics = true;
      this.Hardwere = true;
      this.Kirana = true;
      this.Jewellary = true;
      this.Pharma = false;
      this.Transportation = true;
    } else if (val == "7") {
      this.FMGC = true;
      this.Electronics = true;
      this.Hardwere = true;
      this.Kirana = true;
      this.Jewellary = true;
      this.Pharma = true;
      this.Transportation = false;
    }
  }

  /////////////////////////////////////// set Plocy Type in Session Storage//////////////////////////////////////////////

  checkType(val) {
    let policy_type = val;
    this.storageService.secureStorage.setItem("policy_type", policy_type);
  }
}
